import { Components } from "@mui/material/styles/components";

export default {
  MuiTableCell: {
    styleOverrides: {
      root: {
        fontFamily: "unset",
      },
    },
  } as Components["MuiTableCell"],
};
